const state = {
    months: {
        "1": "Jan",
        "2": "Feb",
        "3": "Mar",
        "4": "Apr",
        "5": "May",
        "6": "Jun",
        "7": "Jul",
        "8": "Aug",
        "9": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec",
    },
    fileTypes: {
        ".mp4": {
            image: "https://sawbo-animations.org/images/download_buttons/computer_mp4.png",
            device: "Computer",
            fileType: ".mp4",
            alt: "Download Mp4",
        },
        ".mov": {
            image: "https://sawbo-animations.org/images/download_buttons/broadcast_mov.png",
            device: "Broadcast",
            fileType: ".mov",
            alt: "Download Mov",
        },
        ".3gp": {
            image: "https://sawbo-animations.org/images/download_buttons/smartphone_3gp.png",
            device: "Smartphone",
            fileType: ".3gp",
            alt: "Download 3gp",
        },
        "Light.3gp": {
            image: "https://sawbo-animations.org/images/download_buttons/cellphone_3gpLite.png",
            device: "Cellphone",
            fileType: ".3gp Lite",
            alt: "Download 3gp Lite",
        },
        ".f4v": {
            image: "https://sawbo-animations.org/images/download_buttons/computer_mp4.png",
            device: "Computer",
            fileType: ".f4v",
            alt: "Download F4v",
        },
        ".flv": {
            image: "https://sawbo-animations.org/images/download_buttons/computer_mp4.png",
            device: "Computer",
            fileType: ".flv",
            alt: "Download Flv",
        },
        ".mp3": {
            image: "https://sawbo-animations.org/images/download_buttons/audio_mp3.png",
            device: "Audio",
            fileType: ".mp3",
            alt: "Download Mp3",
        },
    },
    sdgArray: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
}

const mutations = {
}

const actions = {
}

const getters = {
    months: state => {
        return state.months;
    },
    fileType: state => fileName => {
        let c = fileName.indexOf(".");
        let f = fileName.slice(c);
        if (f === ".3gp" && fileName.includes("_Light.")) {
            f = "Light.3gp";
        }
        return state.fileTypes[f];
    },
    sdgArray: state => {
        return state.sdgArray;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}